/* app/js/src/components/outpost/sidebar/outpost-sidebar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-align-items: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background-color: rgb(255, 255, 255);
  position: fixed;
  width: 220px;
  height: calc(100vh - 17px - 54px - 70px);
  margin-top: 17px;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}
:host::-webkit-scrollbar {
  display: none;
}
.outpost-sidebar {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
.outpost-sidebar ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.outpost-sidebar ul li {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  padding: 15px 15px 15px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.outpost-sidebar ul .outpost-sidebar-header {
  gap: 20px;
}
.outpost-sidebar ul .outpost-sidebar-header .outpost-sidebar-header-label {
  color: rgba(0, 0, 0, 0.85);
  font: "Open Sans", sans-serif;
  font-feature-settings: "liga" off, "clig" off;
  font-style: normal;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
}
.outpost-sidebar ul .outpost-sidebar-item {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 50px;
  gap: 5px;
}
.outpost-sidebar ul .outpost-sidebar-item .outpost-sidebar-icon-wrapper {
  width: 16px;
  height: 16px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  flex-shrink: 0;
}
.outpost-sidebar ul .outpost-sidebar-item .outpost-sidebar-icon {
  width: 16px;
  height: 16px;
  aspect-ratio: 1/1;
}
.outpost-sidebar ul .outpost-sidebar-item .outpost-sidebar-icon ::ng-deep svg circle:first-child {
  stroke: rgb(0, 0, 0);
  stroke-opacity: 0.2;
}
.outpost-sidebar ul .outpost-sidebar-item .outpost-sidebar-icon ::ng-deep svg circle:last-child {
  fill: rgb(0, 0, 0);
  fill-opacity: 0.2;
}
.outpost-sidebar ul .outpost-sidebar-item .outpost-sidebar-icon.online ::ng-deep svg circle:first-child {
  stroke: rgb(45, 187, 252);
  stroke-opacity: 1;
}
.outpost-sidebar ul .outpost-sidebar-item .outpost-sidebar-icon.online ::ng-deep svg circle:last-child {
  fill: rgb(45, 187, 252);
  fill-opacity: 1;
}
.outpost-sidebar ul .outpost-sidebar-item .outpost-sidebar-item-label {
  color: rgba(0, 0, 0, 0.85);
  font: "Open Sans", sans-serif;
  font-feature-settings: "liga" off, "clig" off;
  font-style: normal;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.outpost-sidebar ul .outpost-sidebar-item:hover {
  background-color: rgba(35, 47, 58, 0.05);
  cursor: pointer;
}
.outpost-sidebar ul .outpost-sidebar-item.active {
  background-color: rgba(35, 47, 58, 0.05);
}
/*# sourceMappingURL=outpost-sidebar.component.css.map */
